import { ProcurementCommentCreate } from "@boark/shared/types/procurement-comment-create";
import { ProcurementCommentUpdate } from "@boark/shared/types/procurement-comment-update";
import {
  ProcurementCommentWithCreatedBy,
  procurementCommentWithCreatedBySchema,
} from "@boark/shared/types/procurement-comment-with-created-by";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getProcurementComments(
  procurementId: string,
): Promise<ProcurementCommentWithCreatedBy[]> {
  return getRequest(
    `${API_BASE_URL}/procurement/${procurementId}/comment`,
    z.array(procurementCommentWithCreatedBySchema),
  );
}

export async function createProcurementComment(
  procurementId: string,
  comment: ProcurementCommentCreate,
): Promise<ProcurementCommentWithCreatedBy> {
  return postRequest(
    `${API_BASE_URL}/procurement/${procurementId}/comment`,
    comment,
    procurementCommentWithCreatedBySchema,
  );
}

export async function updateProcurementComment(
  procurementId: string,
  commentId: string,
  comment: ProcurementCommentUpdate,
): Promise<ProcurementCommentWithCreatedBy> {
  return putRequest(
    `${API_BASE_URL}/procurement/${procurementId}/comment/${encodeURIComponent(commentId)}`,
    comment,
    procurementCommentWithCreatedBySchema,
  );
}

export async function deleteProcurementComment(
  procurementId: string,
  commentId: string,
): Promise<void> {
  return deleteRequest(
    `${API_BASE_URL}/procurement/${procurementId}/comment/${encodeURIComponent(commentId)}`,
  );
}
